import DividerBrush from "../components/divider/DividerBrush";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" && staticType === "Divider Brush";

const create = (_data: Record<string, unknown>): JSX.Element => {
  return <DividerBrush />;
};

export default { test, create };
